export default {
  baseStyle: {
    _hover: {
      textDecoration: 'none',
      color: '#008F9D',
    },
  },
};
